"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeInvalidCharactersInHtml = exports.getInvalidCharactersForFoilStamp = void 0;
// NOTE: The eslint-disables in here should be removed and we should update the regexes appropriately.
const getInvalidCharactersForFoilStamp = fontSizeInPt => {
  if (fontSizeInPt === '96') {
    // eslint-disable-next-line no-useless-escape
    return /[^ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789\&\|\s]/g;
  }
  if (fontSizeInPt === '36' || fontSizeInPt === '43' || fontSizeInPt === '14') {
    // eslint-disable-next-line no-useless-escape
    return /[^ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#;,~:\.\&\+\-\/\|\'‘’\s]/g;
  }
  return undefined;
};
exports.getInvalidCharactersForFoilStamp = getInvalidCharactersForFoilStamp;
//Given a font size in pt, it will return a regex wich matches any character not on the list of valid characters.
const removeInvalidCharactersInHtml = (html, fontSizeInPt) => {
  let regex = null;
  if (fontSizeInPt === '96') {
    // eslint-disable-next-line no-useless-escape
    regex = /(<[^>]*>)|[^ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789\&\|\s]/g;
  }
  if (fontSizeInPt === '36' || fontSizeInPt === '43' || fontSizeInPt === '14') {
    // eslint-disable-next-line no-useless-escape
    regex = /(<[^>]*>)|[^ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#;,~:\.\&\+\-\/\|\'\s]/g;
  }
  if (!regex) {
    return html;
  }
  return html.replace(regex, (match, group) => group ? group : '');
};
exports.removeInvalidCharactersInHtml = removeInvalidCharactersInHtml;